import firebase from "firebase/app";
import { firestore, auth, isDemoMode } from '../firebase';
import {suggestionReads} from '../lib/readCache.mjs';
import moment from 'moment-timezone';


function getContainerState(containerObj) {
  let ret = "c";
  if (containerObj !== undefined && containerObj !== null) {
    if (containerObj.eta !== undefined && containerObj.eta !== null && containerObj.eta !== "") {
      ret = "e";
    }
    if (containerObj.lastFreeDay !== undefined && containerObj.lastFreeDay !== null && containerObj.lastFreeDay !== "") {
      ret = "l";
    }
    if (containerObj.pickUpDate !== undefined && containerObj.pickUpDate !== null && containerObj.pickUpDate !== "") {
      ret = "p";
    }
    if (containerObj.apptDate !== undefined && containerObj.apptDate !== null && containerObj.apptDate !== "") {
      ret = "a";
    }
    if (containerObj.deliveryDate !== undefined && containerObj.deliveryDate !== null && containerObj.deliveryDate !== "") {
      ret = "d";
    }
    if (containerObj.returnDate !== undefined && containerObj.returnDate !== null && containerObj.returnDate !== "") {
      ret = "r";
    }
  }
  containerObj.state = ret;
  containerObj.shortString = "test";
  return ret;
}

function getDeliveryOrderState(deliveryOrderObj) {
  let ret = "p";
  if (deliveryOrderObj.c_Return !== undefined && deliveryOrderObj.c_Return !== null && deliveryOrderObj.c_Return.length !== 0) {
    let allContainerReturn = true;
    deliveryOrderObj.c_Return.forEach((element) => {
      if (element === undefined || element === null || element === "") {
        allContainerReturn = false;
      }
    });
    if (allContainerReturn) {
      ret = "r"
    }
  }
  deliveryOrderObj.state = ret;
  return ret;
}

function sanitizeForShortDetail(value) {
  if (typeof value !== "string") return value;
  return value.replace(/-/g, "_");
}

function getValue(value, errortxt) {
  if (value === "") return "[MISSING(" + errortxt + ")]";
  return sanitizeForShortDetail(value)
}

function getFormattedDate(value) {
  if (!value) return "";
  // Both legacy UI dates and tender-mapped ISO dates reach description builders.
  const parsed = moment(value, ["YYYY-MM-DD", "M/D/YYYY", "MM/DD/YYYY"], true);
  return parsed.isValid() ? parsed.format("MM/DD/YYYY") : "";
}

function getRawValue(value, errortxt) {
  if (value === "") return "[MISSING(" + errortxt + ")]";
  return value;
}

function getInvoiceShortDetail(deliveryOrderObj, containerObj, _index) {
  let ref = (deliveryOrderObj.export === true ? "**" : "") + "REF#:" + getRawValue(deliveryOrderObj.cid, "REFERENCE NUMBER");
  let deliveryTo = deliveryOrderObj.deliveryTo !== undefined ?
    (deliveryOrderObj.deliveryTo.shortDetail !== undefined ?
    (deliveryOrderObj.deliveryTo.shortDetail === "/" ? "NA" : deliveryOrderObj.deliveryTo.shortDetail.replace("/", ",")) : "NA") : "NA";
  let index = Array.isArray(deliveryOrderObj.c_Ref) ? deliveryOrderObj.c_Ref.indexOf(containerObj.ref) : -1;
  if (index == null || index < 0){
    if (_index == null){
      index = Array.isArray(deliveryOrderObj.c_Num) ? deliveryOrderObj.c_Num.indexOf(containerObj.number) : -1;
    }else{
      index = _index;
    }
  }
  if (index == null || index < 0) {
    index = 0;
  }

  let locationAddress = getRawValue(deliveryOrderObj.location ? deliveryOrderObj.location.label : "", "LOCATION");

  return ref + "-"
    + deliveryTo + "-"
    + getRawValue(getFormattedDate(getIndex(deliveryOrderObj.c_DeliveryDate, index)), "DELIVERY DATE") + "-"
    + locationAddress
    + ((getIndex(deliveryOrderObj.c_chassisDay, index) !== "") ? ("-CHASSIS DAY(" + getIndex(deliveryOrderObj.c_chassisDay, index) + ")") : "")
    + (getIndex(deliveryOrderObj.c_prePull, index) === true ? "-PREPULL" : "")
    + (getIndex(deliveryOrderObj.c_storage, index) === true ? ("-STORAGE(" + getIndex(deliveryOrderObj.c_storageDay, index) + ")") : "")
    + (getIndex(deliveryOrderObj.c_overWeight, index) === true ? "-OVERWEIGHT" : "")
    + (getIndex(deliveryOrderObj.c_bobTail, index) === true ? "-BOBTAIL" : "")
    + (getIndex(deliveryOrderObj.c_chassisSplit, index) === true ? ("-CHASSIS SPLIT(" + getIndex(deliveryOrderObj.c_chassisSplitFee, index) + ")") : "")
    + "-" + getRawValue(containerObj.number || getIndex(deliveryOrderObj.c_Num, index), "CONTAINER NUMBER")
    + "-" + getRawValue(getIndex(deliveryOrderObj.c_Driver, index), "DELIVERY DRIVER");
}

function getShortDetail(deliveryOrderObj, containerObj, isContainer, _index) {
  let ret = "";
  let ref = (deliveryOrderObj.export === true ? "**" : "") + "REF#:" + getValue(deliveryOrderObj.cid, "REFERENCE NUMBER");
  let deliveryTo = deliveryOrderObj.deliveryTo !== undefined ?
    (deliveryOrderObj.deliveryTo.shortDetail !== undefined ?
    (deliveryOrderObj.deliveryTo.shortDetail === "/" ? "NA" : sanitizeForShortDetail(deliveryOrderObj.deliveryTo.shortDetail.replace("/", ","))) : "NA") : "NA";
  let index = deliveryOrderObj.c_Ref.indexOf(containerObj.ref);
  if (index == null){
    if (_index == null){
      index = deliveryOrderObj.c_Num.indexOf(containerObj.number);
    }else{
      index = _index;
    }
  }
  let locationAddress = getValue(deliveryOrderObj.location ? deliveryOrderObj.location.label : "", "LOCATION");
  // eslint-disable-next-line
  let customerAddress = getValue(deliveryOrderObj.customer ? deliveryOrderObj.customer.label : "", "CUSTOMER");

  if (deliveryOrderObj.state === "r" && isContainer !== true) {
    ret = ref + "-"
    + deliveryTo + "-"
    + getValue(getFormattedDate(deliveryOrderObj.c_DeliveryDate[index]), "DELIVERY DATE") + "-"
    + locationAddress
    + ((deliveryOrderObj.c_chassisDay[index] !== undefined && deliveryOrderObj.c_chassisDay[index] !== "") ? ("-CHASSIS DAY(" + sanitizeForShortDetail("" + deliveryOrderObj.c_chassisDay[index]) + ")") : "")
    + (deliveryOrderObj.c_prePull[index] === true ? "-PREPULL" : "")
    + (deliveryOrderObj.c_storage[index] === true ? ("-STORAGE(" + sanitizeForShortDetail("" + deliveryOrderObj.c_storageDay[index]) + ")") : "")
    + (deliveryOrderObj.c_overWeight[index] === true ? "-OVERWEIGHT" : "")
    + (deliveryOrderObj.c_bobTail && deliveryOrderObj.c_bobTail[index] === true ? "-BOBTAIL" : "")
    + (deliveryOrderObj.c_chassisSplit && deliveryOrderObj.c_chassisSplit[index] === true ? ("-CHASSIS SPLIT(" + sanitizeForShortDetail("" + deliveryOrderObj.c_chassisSplitFee[index]) + ")") : "")
    + "-" + getValue(containerObj.number, "CONTAINER NUMBER")
    + "-" + getValue(deliveryOrderObj.c_Driver[index], "DELIVERY DRIVER");
  }
  else {
    if (containerObj.state === "e") {
      ret = ref + "-"
        + deliveryTo + "-"
        + getValue(getFormattedDate(deliveryOrderObj.c_Eta[index]), "ETA DATE") + "-"
        + locationAddress + "-"
        + getValue(deliveryOrderObj.c_Type[index], "CONTAINER TYPE") + "-"
        + getValue(containerObj.number, "CONTAINER NUMBER");
    }
    if (containerObj.state === "l") {
      ret = ref + "-"
        + deliveryTo + "-"
        + getValue(getFormattedDate(deliveryOrderObj.c_LastFree[index]), "LASTFREE DAY") + "-"
        + locationAddress + "-"
        + getValue(deliveryOrderObj.c_Type[index], "CONTAINER TYPE") + "-"
        + getValue(containerObj.number, "CONTAINER NUMBER");
    }
    if (containerObj.state === "p") {
      ret = ref + "-"
        + deliveryTo + "-"
        + getValue(getFormattedDate(deliveryOrderObj.c_PickUpDate[index]), "PICKUP DATE") + "-"
        + locationAddress + "-"
        + getValue(deliveryOrderObj.c_Type[index], "CONTAINER TYPE") + "-"
        + getValue(containerObj.number, "CONTAINER NUMBER") + "-"
        + getValue(deliveryOrderObj.c_pickupDriver[index], "PICKUP DRIVER") + "-"
        + getValue(deliveryOrderObj.c_Chassis[index], "CHASSIS INFO");
    }
    if (containerObj.state === "a") {
      ret = ref + "-"
        + deliveryTo + "-"
        + getValue(getFormattedDate(deliveryOrderObj.c_PickUpDate[index]), "PICKUP DATE") + "-"
        + locationAddress + "-"
        + getValue(deliveryOrderObj.c_Type[index], "CONTAINER TYPE") + "-"
        + getValue(containerObj.number, "CONTAINER NUMBER") + "-"
        + getValue(deliveryOrderObj.c_Chassis[index], "CHASSIS INFO") + "-"
        + getValue(deliveryOrderObj.c_Driver[index], "DELIVERY DRIVER");
    }
    if (containerObj.state === "d") {
      ret = ref + "-"
        + deliveryTo + "-"
        + getValue(getFormattedDate(deliveryOrderObj.c_PickUpDate[index]), "PICKUP DATE") + "-"
        + locationAddress + "-"
        + getValue(deliveryOrderObj.c_Type[index], "CONTAINER TYPE") + "-"
        + getValue(containerObj.number, "CONTAINER NUMBER") + "-"
        + getValue(deliveryOrderObj.c_Chassis[index], "CHASSIS INFO") + "-"
        + getValue(deliveryOrderObj.c_cLocation[index], "CONTAINER LOCATION") + "-"
        + sanitizeForShortDetail(getLabel(deliveryOrderObj.carrier)) + "-"
        + getValue(deliveryOrderObj.c_containerComment[index], "CONTAINER NOTE");
    }
    if (containerObj.state === "r") {
      ret = ref + "-"
        + deliveryTo + "-"
        + getValue(getFormattedDate(deliveryOrderObj.c_DeliveryDate[index]), "DELIVERY DATE") + "-"
        + locationAddress
        + ((deliveryOrderObj.c_chassisDay[index] !== undefined && deliveryOrderObj.c_chassisDay[index] !== "") ? ("-CHASSIS DAY(" + sanitizeForShortDetail("" + deliveryOrderObj.c_chassisDay[index]) + ")") : "")
        + (deliveryOrderObj.c_prePull[index] === true ? "-PREPULL" : "")
        + (deliveryOrderObj.c_storage[index] === true ? ("-STORAGE(" + sanitizeForShortDetail("" + deliveryOrderObj.c_storageDay[index]) + ")") : "")
        + (deliveryOrderObj.c_overWeight[index] === true ? "-OVERWEIGHT" : "")
        + (deliveryOrderObj.c_bobTail && deliveryOrderObj.c_bobTail[index] === true ? "-BOBTAIL" : "")
        + (deliveryOrderObj.c_chassisSplit && deliveryOrderObj.c_chassisSplit[index] === true ? ("-CHASSIS SPLIT(" + sanitizeForShortDetail("" + deliveryOrderObj.c_chassisSplitFee[index]) + ")") : "")
        + "-" + getValue(containerObj.number, "CONTAINER NUMBER")
        + "-" + getValue(deliveryOrderObj.c_Driver[index], "DELIVERY DRIVER")
    }
    if (containerObj.state === undefined) {
      ret = ref + "-"
      + deliveryTo + "-"
      + getValue(getFormattedDate(deliveryOrderObj.c_DeliveryDate[index]), "DELIVERY DATE") + "-"
      + locationAddress
      + "-" + getValue(containerObj.number, "CONTAINER NUMBER")
      + "-" + getValue(deliveryOrderObj.c_Driver[index], "DELIVERY DRIVER")

    }
  }

  deliveryOrderObj.shortDetail = ret;
  containerObj.shortDetail = ret;
  return ret;
}

function getArray(field, length) {
  if (field) return field;
  return Array(length !== undefined ? length : 1).fill("");
}

function getBranchValue(branch) {
  if (branch && branch.label) {
    return branch.label;
  }
  return branch || "NY";
}

function getBranchTimeZone(branch) {
  let branchValue = getBranchValue(branch);
  return branchValue === "CHI" || branchValue === "CHICAGO" ? "America/Chicago" : "America/New_York";
}

function getBranchDisplayName(branch) {
  let branchValue = getBranchValue(branch);
  return branchValue === "CHI" || branchValue === "CHICAGO" ? "Chicago" : "New York";
}

function getBranchCollectionSuffix(branch) {
  let branchValue = getBranchValue(branch);
  return branchValue === "CHI" || branchValue === "CHICAGO" ? "_chi" : "_ny";
}

function getBranchCollectionName(collection, branch) {
  return `${collection}${getBranchCollectionSuffix(branch)}`;
}

function normalizeRecordKeySegment(value) {
  return `${value || ""}`
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 120);
}

function getDriverRecordDocId(name) {
  let normalizedName = normalizeRecordKeySegment(name);
  return normalizedName === "" ? "" : `DRV_${normalizedName}`;
}

function getNamedRecordDocId(collection, name) {
  let normalizedName = normalizeRecordKeySegment(name);
  if (normalizedName === "") {
    return "";
  }

  if (collection === "drivers") {
    return getDriverRecordDocId(name);
  }

  let normalizedCollection = normalizeRecordKeySegment(collection);
  return normalizedCollection === "" ? `REC_${normalizedName}` : `${normalizedCollection}_${normalizedName}`;
}

function getDeliveryOrderDocId(cid) {
  let normalizedCid = normalizeRecordKeySegment(cid);
  return normalizedCid === "" ? "" : `DO_${normalizedCid}`;
}

function normalizeDateLike(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value.toDate === "function") {
    return value.toDate();
  }

  let normalized = new Date(value);
  return Number.isNaN(normalized.getTime()) ? null : normalized;
}

function compareDateLike(a, b, nullsLast = false) {
  const normalizedA = normalizeDateLike(a);
  const normalizedB = normalizeDateLike(b);

  if (!normalizedA && !normalizedB) {
    return 0;
  }

  if (!normalizedA) {
    return nullsLast ? 1 : -1;
  }

  if (!normalizedB) {
    return nullsLast ? -1 : 1;
  }

  return normalizedA.getTime() - normalizedB.getTime();
}

function getBranchMoment(value, branch) {
  let normalizedDate = normalizeDateLike(value);
  if (!normalizedDate) {
    return null;
  }

  return moment(normalizedDate).tz(getBranchTimeZone(branch));
}

function getBranchCalendarDate(value, branch) {
  let branchMoment = getBranchMoment(value, branch);
  if (!branchMoment) {
    return null;
  }

  return new Date(
    branchMoment.year(),
    branchMoment.month(),
    branchMoment.date(),
    branchMoment.hour(),
    branchMoment.minute(),
    branchMoment.second(),
    branchMoment.millisecond()
  );
}

function formatInBranchTimeZone(value, branch, formatString) {
  let branchMoment = getBranchMoment(value, branch);
  if (!branchMoment) {
    return "";
  }

  return branchMoment.format(formatString);
}

function getBranchTimeZoneAbbr(value, branch) {
  return formatInBranchTimeZone(value, branch, "z");
}

function normalizeBranchDateInput(date) {
  if (!date) {
    return "";
  }

  let parsedDate = moment(date, ["YYYY-MM-DD", "YYYY-M-D", "M/D/YYYY", "MM/DD/YYYY"], true);
  return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
}

function normalizeBranchTimeInput(time) {
  if (!time) {
    return "00:00:00";
  }

  let parsedTime = moment(time, ["HH:mm", "HH:mm:ss", "H:mm", "h:mm A", "h:mmA"], true);
  return parsedTime.isValid() ? parsedTime.format("HH:mm:ss") : "";
}

function getBranchDateTimeResolution(date, time, branch, ambiguityChoice) {
  if (date === undefined || date === null || date === "") {
    return {
      status: "empty",
      timestamp: null,
      candidates: [],
      options: [],
      message: "",
    };
  }

  let normalizedDate = normalizeBranchDateInput(date);
  let normalizedTime = normalizeBranchTimeInput(time);
  let branchName = getBranchDisplayName(branch);
  let timeZone = getBranchTimeZone(branch);

  if (!normalizedDate) {
    return {
      status: "invalid",
      timestamp: null,
      candidates: [],
      options: [],
      message: `The selected date is invalid for ${branchName} time.`,
    };
  }

  if (!normalizedTime) {
    return {
      status: "invalid",
      timestamp: null,
      candidates: [],
      options: [],
      message: `The selected time is invalid for ${branchName} time.`,
    };
  }

  let zone = moment.tz.zone(timeZone);
  if (!zone) {
    return {
      status: "invalid",
      timestamp: null,
      candidates: [],
      options: [],
      message: `Cannot resolve ${branchName} time zone information.`,
    };
  }

  let localDateTime = `${normalizedDate} ${normalizedTime}`;
  let parsedBranchMoment = moment.tz(localDateTime, "YYYY-MM-DD HH:mm:ss", timeZone);
  let [year, month, day] = normalizedDate.split("-").map(Number);
  let [hour, minute, second] = normalizedTime.split(":").map(Number);
  let naiveUtcMillis = Date.UTC(year, month - 1, day, hour, minute, second || 0);

  let candidateOffsets = new Set([
    zone.utcOffset(parsedBranchMoment.valueOf()),
    zone.utcOffset(parsedBranchMoment.valueOf() - 7200000),
    zone.utcOffset(parsedBranchMoment.valueOf() - 3600000),
    zone.utcOffset(parsedBranchMoment.valueOf()),
    zone.utcOffset(parsedBranchMoment.valueOf() + 3600000),
    zone.utcOffset(parsedBranchMoment.valueOf() + 7200000),
  ]);

  let candidates = [];
  candidateOffsets.forEach((offsetMinutes) => {
    let candidateUtcMillis = naiveUtcMillis + offsetMinutes * 60000;
    let candidateMoment = moment.tz(candidateUtcMillis, timeZone);
    if (candidateMoment.format("YYYY-MM-DD HH:mm:ss") === localDateTime) {
      if (candidates.findIndex(candidate => candidate.utcMillis === candidateUtcMillis) === -1) {
        candidates.push({
          utcMillis: candidateUtcMillis,
          moment: candidateMoment,
          abbr: candidateMoment.format("z"),
          timestamp: firebase.firestore.Timestamp.fromDate(candidateMoment.toDate()),
        });
      }
    }
  });

  candidates.sort((a, b) => a.utcMillis - b.utcMillis);

  let displayTime = moment(normalizedTime, "HH:mm:ss").format("h:mm A");
  let displayDate = moment(normalizedDate, "YYYY-MM-DD").format("MMMM D, YYYY");

  if (candidates.length === 0) {
    return {
      status: "nonexistent",
      timestamp: null,
      candidates: [],
      options: [],
      message: `${displayTime} does not exist on ${displayDate} in ${branchName} time because of daylight saving. Please choose another time.`,
    };
  }

  if (candidates.length > 1) {
    let options = candidates.map((candidate, index) => ({
      id: index === 0 ? "earlier" : "later",
      label: `${index === 0 ? "Earlier" : "Later"} ${displayTime} (${candidate.abbr})`,
      abbr: candidate.abbr,
      timestamp: candidate.timestamp,
    }));

    if (ambiguityChoice === "earlier" || ambiguityChoice === "later") {
      let chosenOption = options.find(option => option.id === ambiguityChoice) || options[0];
      return {
        status: "valid",
        timestamp: chosenOption.timestamp,
        candidates,
        options,
        selectedChoice: chosenOption.id,
        message: "",
      };
    }

    return {
      status: "ambiguous",
      timestamp: null,
      candidates,
      options,
      message: `${displayTime} happens twice on ${displayDate} in ${branchName} time because of daylight saving. Choose the earlier or later ${displayTime}.`,
      displayDate,
      displayTime,
      branchName,
    };
  }

  return {
    status: "valid",
    timestamp: candidates[0].timestamp,
    candidates,
    options: [],
    message: "",
  };
}

function getDateTime(date, time, branch) {
  // if zone not chi , alway treat as Eastern time
  moment.tz.add([
    'America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6',
    "America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
  ]);
  let timeZone = branch.label === "CHICAGO" ? "America/Chicago" : "America/New_York";
  if (date !== undefined && date !== "") {
    var local = moment.tz(date + " " + (time ? time : "00:00"), timeZone);
    return firebase.firestore.Timestamp.fromDate(local.toDate());
  }
  return null;
}

function getContent(field) {
  if (field) return field;
  return "";
}

function getBool(field) {
  return field === true || field === "true";
}

function getLabel(field) {
  if (field && field.label) return field.label;
  return "";
}

function getId(field) {
  if (field && field.ref && field.ref.id) return field.ref.id;
  return "";
}

function getRef(field) {
  if (field && field.ref) return field.ref;
  return "";
}

function getIndex(field, index) {
  if (field !== undefined) return field[index];
  return "";
}

function handleInfoQuery(collection, setFn, showHide, branch) {
  let branchLabel = branch === "CHI" ? "_chi" : "_ny";
  return suggestionReads.read(`${auth.currentUser?.uid}:${isDemoMode()}:${collection + branchLabel}`, () => firestore.collection(`${collection + branchLabel}`).get()).then((querySnapshot) => {
    var infoMap = new Map();
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
        if ((showHide === true || obj.addressHide !== true)) {
          infoMap.set(obj.name, doc.id);
        }
    });
    setFn([...infoMap]);
  });
}

// user , systemReport
function handleUpdate(collection, docRef, obj, thenFn, errFn) {
  updateQueryBuilder(collection, docRef, obj, thenFn, errFn);
}

// resultFields
function handleFetchByReference(collection, docRef, thenFn, errFn) {
  firestore.collection(`${collection}`)
  .doc(docRef)
  .get()
  .then(doc => {
    thenFn(doc);
  })
  .catch(err => {
    errFn(err);
  });
}

function addressQueryBuilder(collection, addressObject) {
  return getId(addressObject) !== ""
  ? firestore
    .collection(collection)
    .doc(addressObject.ref.id)
    .get()
  : undefined;
}

function collectQueryBuilder(collection) {
  return firestore
    .collection(collection)
    .get();
}

function addQueryBuilder(collection, obj, thenFn, errFn) {
  return firestore
    .collection(collection)
    .add(obj)
    .then(doc => {
      suggestionReads.clear();
      thenFn(doc);
    })
    .catch(err => {
      errFn(err);
    });
}

function upsertNamedRecord(collection, docId, obj, thenFn, errFn) {
  return firestore
    .collection(collection)
    .doc(docId)
    .set(obj, { merge: true })
    .then(doc => {
      suggestionReads.clear();
      thenFn(doc);
    })
    .catch(err => {
      errFn(err);
    });
}

function createDocumentIfAbsent(collection, docId, obj, thenFn, errFn) {
  let docRef = firestore.collection(collection).doc(docId);

  return firestore
    .runTransaction(async transaction => {
      let existingDoc = await transaction.get(docRef);
      if (existingDoc.exists) {
        throw new Error(`Document already exists: ${docId}`);
      }
      transaction.set(docRef, obj);
      return docRef;
    })
    .then(ref => {
      suggestionReads.clear();
      thenFn(ref);
    })
    .catch(err => {
      errFn(err);
    });
}

function updateQueryBuilder(collection, docId, obj, thenFn, errFn) {
  return firestore
    .collection(collection)
    .doc(docId)
    .update(obj)
    .then(doc => {
      suggestionReads.clear();
      thenFn(doc);
    })
    .catch(err => {
      errFn(err);
    });
}

function commitbatch(batch, thenFn, errFn) {
  batch.commit().then(
    () => {
      suggestionReads.clear();
      thenFn();
    },
    dbErr => {
      errFn(dbErr);
    }
  );
}

export default class Helper {

  static getContainerState(containerObj) { return getContainerState(containerObj); }

  static getDeliveryOrderState(deliveryOrderObj) { return getDeliveryOrderState(deliveryOrderObj); }

  static getInvoiceShortDetail(deliveryOrderObj, containerObj, _index) {
    return getInvoiceShortDetail(deliveryOrderObj, containerObj, _index);
  }

  static getShortDetail(deliveryOrderObj, containerObj, isContainer, _index) { return getShortDetail(deliveryOrderObj, containerObj, isContainer, _index); }

  static getArray(field, length) { return getArray(field, length); }

  static getBranchTimeZone(branch) { return getBranchTimeZone(branch); }

  static getBranchDisplayName(branch) { return getBranchDisplayName(branch); }

  static getBranchCollectionSuffix(branch) { return getBranchCollectionSuffix(branch); }

  static getBranchCollectionName(collection, branch) { return getBranchCollectionName(collection, branch); }

  static getDriverRecordDocId(name) { return getDriverRecordDocId(name); }

  static getNamedRecordDocId(collection, name) { return getNamedRecordDocId(collection, name); }

  static getDeliveryOrderDocId(cid) { return getDeliveryOrderDocId(cid); }

  static getBranchMoment(value, branch) { return getBranchMoment(value, branch); }

  static getBranchCalendarDate(value, branch) { return getBranchCalendarDate(value, branch); }

  static compareDateLike(a, b, nullsLast) { return compareDateLike(a, b, nullsLast); }

  static formatInBranchTimeZone(value, branch, formatString) { return formatInBranchTimeZone(value, branch, formatString); }

  static getBranchTimeZoneAbbr(value, branch) { return getBranchTimeZoneAbbr(value, branch); }

  static getBranchDateTimeResolution(date, time, branch, ambiguityChoice) {
    return getBranchDateTimeResolution(date, time, branch, ambiguityChoice);
  }

  static getDateTime(date, time, branch)  { return getDateTime(date, time, branch); }

  static normalizeBranchDateInput(date) { return normalizeBranchDateInput(date); }

  static getContent(field) { return getContent(field); }

  static getBool(field) { return getBool(field); }

  static getLabel(field) { return getLabel(field); }

  static getId(field) { return getId(field); }

  static getRef(field) { return getRef(field); }

  static getIndex(field, index) { return getIndex(field, index); }

  static handleInfoQuery(collection, setFn, showHide, branch){return handleInfoQuery(collection, setFn, showHide, branch);}

  static handleUpdate(collection, docRef, obj, thenFn, errFn){return handleUpdate(collection, docRef, obj, thenFn, errFn);}

  static handleFetchByReference(collection, docRef, thenFn, errFn){return handleFetchByReference(collection, docRef, thenFn, errFn);}

  static addressQueryBuilder(collection, addressObject){return addressQueryBuilder(collection, addressObject);}

  static collectQueryBuilder(collection){return collectQueryBuilder(collection);}

  static addQueryBuilder(collection, obj, thenFn, errFn){return addQueryBuilder(collection, obj, thenFn, errFn);}

  static upsertNamedRecord(collection, docId, obj, thenFn, errFn){return upsertNamedRecord(collection, docId, obj, thenFn, errFn);}

  static createDocumentIfAbsent(collection, docId, obj, thenFn, errFn){return createDocumentIfAbsent(collection, docId, obj, thenFn, errFn);}

  static updateQueryBuilder(collection, docId, obj, thenFn, errFn){return updateQueryBuilder(collection, docId, obj, thenFn, errFn);}

  static commitbatch(batch, thenFn, errFn) {return commitbatch(batch, thenFn, errFn);}

}
